import {Component} from '@angular/core';

@Component({
    selector: 'vr-loader',
    template: `
  <div class="loader">
  <img src="../assets/img/agnextloader.gif">
  </div>
  `
})

export class LoaderComponent {
    constructor() {
    }
}
